import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonFilled, Text } from 'Components/Base';

const ClearButton = ({ onOpenClearModal }) => {
  const { t } = useTranslation('classroom');

  return (
    <ButtonFilled onClick={onOpenClearModal} px={{ _: 4, md: 5 }} py={2} color={'white'}>
      <Text textStyle={'subtitle1'} color={'black'} fontWeight={'bold'}>
        {t('CLEAR_BY_LEARNED.BUTTON_TEXT')}
      </Text>
    </ButtonFilled>
  );
};

ClearButton.propTypes = {
  onOpenClearModal: PropTypes.func,
};

ClearButton.defaultProps = {
  onClick: () => {},
};

export default ClearButton;
